import { unknownProfiles } from "../../utils/profile";

export function getWidth() {
    return Math.max(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
    );
}

export function generateDate(date) {
    const localDate = new Date(date + " UTC")
    return localDate.toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, minute: '2-digit', second: '2-digit' }).replace(/,/g, "")
  }

export function minifyRailcar(railcar) {
    const cargo = railcar.event_groups ? railcar.event_groups.map(c => {
        return {
          cargoType: c.type.name_en,
          cargoProfileId: c.profile.id,
          cargoPosition: c.attributes.filter(a => a.id === 285)[0].value,
          cargoEventId: c.id,
          cargoDetectionStatus: unknownProfiles.includes(c.profile.id) ? "unmatched" : "matched",
        }
      }) : [];

    const cargoTypes = [...new Set(cargo.map(c => c.cargoType))]

    return {
        railcarName: railcar.profile.name,
        railcarId: railcar.id,
        railcarProfileId: railcar.profile.id,
        railcarType: railcar.attributes.filter(attr => attr.id === 283)[0].value,
        sequenceNo: railcar.attributes.filter(attr => attr.id === 121)[0].value,
        railcarEventId: railcar.id,
        cargo: cargo,
        cargoTypes: cargoTypes,
    }
}

export function isRailcarVisible(railcar, railcarFilter, matchFilter) {
  // TODO: Make the train carousel use this function.
  let visible = true;
  if (railcarFilter) {
    if (typeof railcarFilter === "number") {
      if (railcar.railcarType !== railcarFilter) {
        visible = false;
      }
    } else {
      if (!railcar.cargoTypes.includes(railcarFilter)) {
        visible = false;
      }
    }
  }
  if (visible) {
    if (matchFilter) {
      if (matchFilter === "matched") {
        if (railcar.cargo[0] && typeof railcarFilter === "string") {
          visible = railcar.cargo.map(c => c.cargoDetectionStatus).includes("matched"); 
        } else {
          visible = !unknownProfiles.includes(railcar.railcarProfileId);
        }
      } else if (matchFilter === "unmatched") {
        if (railcar.cargo[0] && (typeof railcarFilter === "string" || railcarFilter === 0)) {
          visible = railcar.cargo.map(c => c.cargoDetectionStatus).includes("unmatched");
        } else {
          visible = unknownProfiles.includes(railcar.railcarProfileId)
        }
      }
    }
  }
  return visible;
}

export function returnRailcarName(id) {
    if (id === 171) {
      return "Locomotive"
    } else if (id === 172) {
      return "Maintenance"
    } else if (id === 173) {
      return "AutoRack"
    } else if (id === 174) {
      return "BoxCar"
    } else if (id === 175) {
      return "RefrigeratedBoxCar"
    } else if (id === 176) {
      return "CenterBeam"
    } else if (id === 177) {
      return "ClosedHopper" 
    } else if (id === 178) {
      return "OpenHopper" 
    } else if (id === 179) {
      return "Gondola"
    } else if (id === 180) {
      return "Tanker"
    } else if (id === 181) {
      return "WellCar"
    } else if (id === 182) {
      return "Flatcar"
    } else if (id === 183) {
      return "Passenger"
    } else if (id === 185) {
      return "CoilCar"
    }
  }